export default [
  {
    path: '/catalog/:id',
    name: 'catalog',
    component: () => import(/* webpackChunkName: "catalog-routes" */ '@/views/Catalog/Catalog'),
    reverse: 'catalogs-single'
  },
  {
    path: '/catalog-pricing',
    name: 'catalog-pricing',
    component: () => import(/* webpackChunkName: "catalog-routes" */ '@/views/Catalog/CatalogPricing'),
    meta: { permission: 'api.view_catalog' }
  },
  {
    path: '/catalog-list',
    name: 'catalog-list',
    component: () => import(/* webpackChunkName: "catalog-routes" */ '@/views/Catalog/CatalogList'),
    meta: { permission: 'api.view_catalog' }
  },
  {
    path: '/ppm-calculation/:id',
    name: 'ppm-calculation',
    component: () => import(/* webpackChunkName: "catalog-routes" */ '@/views/PpmCalculation/PpmCalc'),
    reverse: 'ppm_calculations-single'
  },
  {
    path: '/ppm-calculation-list',
    component: () => import(/* webpackChunkName: "catalog-routes" */ '@/views/PpmCalculation/PpmCalcParent'),
    children: [
      {
        path: '',
        name: 'ppm-calculation-list',
        component: () => import(/* webpackChunkName: "catalog-routes" */ '@/views/PpmCalculation/PpmCalculationList'),
        meta: { permission: 'api.view_ppmcalculation' }
      },
      {
        path: '/create-ppm-calculation',
        name: 'create-ppm-calculation',
        component: () => import(/* webpackChunkName: "catalog-routes" */ '@/views/PpmCalculation/CreatePpmCalculation'),
        meta: { permission: 'api.add_ppmcalculation' }
      }
    ]
  }
]
